<h2 mat-dialog-title class="title-small">Download Statement</h2>

<mat-dialog-content class="mat-typography statement-period-dialog">
    <form [formGroup]="form" fxLayout="column" fxLayoutGap="16px">
        <span class="body-1-regular-2">
            Choose the payment period to export. Month to date is selected by default.
        </span>

        <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="16px">
            <mat-form-field fxFlex class="custom-text-field" appearance="outline" floatLabel="always">
                <mat-label>Start Date</mat-label>
                <input matInput [matDatepicker]="startPicker" formControlName="startDate" [max]="today">
                <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                <mat-datepicker #startPicker></mat-datepicker>
                <mat-error *ngIf="form.get('startDate')?.hasError('required')">Start date is required</mat-error>
            </mat-form-field>

            <mat-form-field fxFlex class="custom-text-field" appearance="outline" floatLabel="always">
                <mat-label>End Date</mat-label>
                <input matInput [matDatepicker]="endPicker" formControlName="endDate" [max]="today">
                <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                <mat-datepicker #endPicker></mat-datepicker>
                <mat-error *ngIf="form.get('endDate')?.hasError('required')">End date is required</mat-error>
            </mat-form-field>
        </div>

        <span class="body-1-error" *ngIf="form.hasError('dateOrder')">
            Start date must be before or equal to end date.
        </span>
        <span class="body-1-error" *ngIf="form.hasError('futureDate')">
            Statement dates cannot be in the future.
        </span>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end" class="statement-period-actions">
    <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
    <button class="button-action" mat-flat-button type="button" (click)="download()">
        <mat-icon>download</mat-icon>
        <div class="button-text">Download</div>
    </button>
</mat-dialog-actions>
